import { render, staticRenderFns } from "./serive.vue?vue&type=template&id=38d56276&scoped=true&"
import script from "./serive.vue?vue&type=script&lang=js&"
export * from "./serive.vue?vue&type=script&lang=js&"
import style0 from "./serive.vue?vue&type=style&index=0&id=38d56276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d56276",
  null
  
)

export default component.exports